import React, {useCallback, useEffect, useMemo, useState} from "react";
import Breadcrumbs from "./../../../../../ui/Breadcrumbs";
import { deletePersons } from "../../../Person/store/deleteactions";
import { importPersons } from "../../../Person/store/send";
import useQuery from "../../../../../ui/QueryTable/useQuery";
import QueryTable from "../../../../../ui/QueryTable";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import AddPersonModal from "../../../Person/components/PersonTable/AddPersonModal";
import ImportModal from "../../../Person/components/PersonTable/ImportModal";
import {makeStyles} from "@material-ui/core/styles";
import AddButton from "../../../../../ui/AddButton";
import PersonDrawer from "../../../Person/components/PersonDrawer";
import {connect} from "react-redux";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Пользователи платформы",
    link: "/work/app/manage/resources/users"
  }
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const UserList = ({deletePersons, importPersons,
                      isDeletingPersons, isImportingPersons}) => {
  const [focusedPerson, setFocusedPerson] = useState(-1);
  const [selection, setSelection] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const {root} = useStyles();
  const query = useQuery(14);

  const actionsDisabled = isDeletingPersons || isImportingPersons;

  const deletePersonsChain = useCallback(() => {
    return deletePersons(selection)
      .then(() => {
        setDeleteOpen(false);
        query.refresh();
      }, () => {
        setDeleteOpen(false);
        query.refresh();
      })
  }, [setDeleteOpen, deletePersons, selection, query]);

  const TableRowClick = useCallback((e) => {
    const focusedPerson = e ? e.key : -1;
    setFocusedPerson(focusedPerson);
  }, [setFocusedPerson]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteOpen(!deleteOpen);
  }, [deleteOpen]);

  const showAddModal = useCallback(() => {
    setAddOpen(!addOpen)
  }, [addOpen]);

  const showImportModal = useCallback(() => {
    setImportOpen(!importOpen)
  }, [importOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
      {
        label: "Импорт сотрудников",
        onClick: showImportModal
      },
    ]
  }, [showDeleteModal, actionsDisabled, selection, showImportModal]);

  useEffect(() => {
    query.load();
  }, []);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить выбранных сотрудников?"
        open={deleteOpen}
        onConfirm={deletePersonsChain}
        handleClose={showDeleteModal}
      />
      <AddPersonModal
        open={addOpen}
        handleClose={showAddModal}
      />
      <ImportModal
        onImport={importPersons}
        open={importOpen}
        isImportingPersons={isImportingPersons}
        handleClose={showImportModal}
      />
      <Breadcrumbs items={items} />
      <div className={root}>
        <QueryTable
          focusedId={focusedPerson}
          onSelectionChanged={TableSelectionChanged}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={showAddModal}/>}
          secondaryActions={secondaryActions}
          {...query} />
        <PersonDrawer
          personId={focusedPerson}
          open={focusedPerson !== -1}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isDeletingPersons: state.persons.isDeletingPersons,
  isImportingPersons: state.persons.isImportingPersons
});

const mapDispatchToProps = dispatch => ({
  importPersons: (data) => dispatch(importPersons(data)),
  deletePersons: idList => dispatch(deletePersons(idList))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserList);
